<script setup lang="ts">
import { AlertType } from '@/store/uiStore';

const props = defineProps<{
  variant: AlertType;
  message: string;
}>();

const icons = {
  info: 'Info',
  success: 'CheckCircle',
  warning: 'AlertTriangle',
  danger: 'AlertCircle',
} as const;

const iconName = computed(() => icons[props.variant]);
defineEmits(['close']);
</script>

<template>
  <div class="ui-notification" :data-variant="variant">
    <UiIcon :name="iconName" :size="20" class="icon" />
    <p class="message">{{ message }}</p>
    <UiButton variant="flat" class="close-icon-button" @click="$emit('close')">
      <UiIcon name="XIcon" class="close-icon" />
    </UiButton>
  </div>
</template>

<style lang="scss" scoped>
.ui-notification {
  padding: var(--space-16);
  font-size: var(--font-size-14);
  margin: var(--space-8);
  background: white;
  border-radius: var(--border-radius-12);
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);

  &[data-variant='info'] {
    border: var(--color-bluelight-500) 1px solid;
    color: var(--color-bluelight-600);
  }

  &[data-variant='success'] {
    border: var(--color-success-400) 1px solid;
    color: var(--color-success-400);
  }

  &[data-variant='warning'] {
    border: var(--color-warning-500) 1px solid;
    color: var(--color-warning-500);
  }

  &[data-variant='danger'] {
    border: var(--color-error-600) 1px solid;
    color: var(--color-error-600);
  }
}

p.message {
  color: var(--color-gray-600);
  float: left;
}

.icon {
  margin-right: var(--space-10);
  float: left;
}

.close-icon-button.ui-button {
  padding: 0 0 0 var(--space-10);
}

.close-icon {
  height: 1rem;
  width: 1rem;
  color: var(--color-gray-500);
  cursor: pointer;
}
</style>
